import { useMutation } from "@tanstack/react-query";
import { LOGIN } from "./endpoints";
import { postRequest } from "./axiosClient";

export const useLogin = () => {
	return useMutation({
		mutationFn: ({ user, password, event, supervisorDNI }) => {
			return postRequest(
				`${LOGIN}?u=${user}&c=${password}&e=${event}${
					supervisorDNI ? `&s=${supervisorDNI}` : ""
				}`
			);
		},
	});
};
